"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_transition_group_1 = require("react-transition-group");
const styled_components_1 = __importStar(require("styled-components"));
const CutHole_1 = __importDefault(require("../../../molecules/CutHole"));
const ToolsCutLayers_1 = __importDefault(require("../../../molecules/ToolsCutLayers"));
const CutLines_1 = __importDefault(require("../../../molecules/CutLines"));
const ToolsCutOptions_1 = __importDefault(require("../../../molecules/ToolsCutOptions"));
const ToolsMode_1 = __importDefault(require("../../../templates/ToolsMode"));
const providers_1 = require("../../../providers");
const ui_1 = require("@completeanatomy/ui");
const i18n_1 = require("@completeanatomy/i18n");
const animation_1 = require("../../../utils/animation");
const bridge_1 = require("@completeanatomy/bridge");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const useCutOptions_1 = require("../../../hooks/useCutOptions");
const getTitle = (selectedSubType, isCutLineDrawn) => {
    switch (selectedSubType) {
        case bridge_schema_1.ToolType.Cut1Side:
            return isCutLineDrawn
                ? (0, i18n_1.Localized)(i18n_1.Strings.tools.cut.titleSide)
                : (0, i18n_1.Localized)(i18n_1.Strings.tools.cut.titleLine);
        case bridge_schema_1.ToolType.CutBetween:
            return isCutLineDrawn
                ? (0, i18n_1.Localized)(i18n_1.Strings.tools.cut.titleAnotherBetween)
                : (0, i18n_1.Localized)(i18n_1.Strings.tools.cut.titleBetween);
        default:
            return (0, i18n_1.Localized)(i18n_1.Strings.tools.cut.titleHole);
    }
};
function ToolCutModePage({ subtype }) {
    var _a;
    const [isUIHidden, toggleUIHidden] = (0, ui_1.useToggleState)(false);
    const [{ isCutLineDrawn }] = (0, providers_1.useToolsModeContext)();
    const size = (0, ui_1.useScreenSize)();
    const theme = (0, styled_components_1.useTheme)();
    const bridge = (0, bridge_1.useBridge)();
    const [searchParams] = (0, react_router_dom_1.useSearchParams)();
    const subtypeFromURLParams = Number(searchParams.get('subtype')) || subtype || bridge_schema_1.ToolType.Cut1Side;
    const selectedTypeFromURLParams = Number(searchParams.get('selectedType')) || bridge_schema_1.ToolType.SingleCutLayer;
    const isShowLines = subtype === bridge_schema_1.ToolType.Cut1Side ||
        subtype === bridge_schema_1.ToolType.CutBetween ||
        subtypeFromURLParams === bridge_schema_1.ToolType.Cut1Side ||
        subtypeFromURLParams === bridge_schema_1.ToolType.CutBetween;
    const [selectedSubType, setSelectedSubType] = (0, react_1.useState)((_a = subtypeFromURLParams !== null && subtypeFromURLParams !== void 0 ? subtypeFromURLParams : subtype) !== null && _a !== void 0 ? _a : bridge_schema_1.ToolType.Cut1Side);
    const [selectedType, setSelectedType] = (0, react_1.useState)(selectedTypeFromURLParams || bridge_schema_1.ToolType.SingleCutLayer);
    const { subtype: cutSubtype, type } = (0, useCutOptions_1.useCutOptions)();
    (0, react_1.useEffect)(() => {
        bridge === null || bridge === void 0 ? void 0 : bridge.performToolkitAction({
            type: cutSubtype,
            currentOptions: {
                type: cutSubtype,
                cutMode: type,
                lineIsDrawn: false,
            },
            senderID: 'tool-cut',
        });
        setSelectedSubType(cutSubtype);
        setSelectedType(type);
    }, [bridge, cutSubtype, type]);
    return ((0, jsx_runtime_1.jsxs)(ToolsMode_1.default, { title: getTitle(selectedSubType, isCutLineDrawn), clearTitle: (0, i18n_1.Localized)(i18n_1.Strings.tools.cut.clear), onToggleUI: toggleUIHidden, "data-e2e": 'ToolCutModePage_ToolsModeTemplate', children: [isShowLines &&
                (selectedSubType === bridge_schema_1.ToolType.Cut1Side ||
                    selectedSubType === bridge_schema_1.ToolType.CutBetween) && ((0, jsx_runtime_1.jsx)(CutLines_1.default, { width: size.width, height: size.height, color: theme.white, strokeColor: theme.gray, selectedType: selectedType, subtype: selectedSubType, "data-e2e": 'ToolCutModePage_ToolsCutLines' })), (selectedSubType === bridge_schema_1.ToolType.CutHole ||
                subtypeFromURLParams === bridge_schema_1.ToolType.CutHole) && ((0, jsx_runtime_1.jsx)(CutHole_1.default, { width: size.width, height: size.height, color: theme.white, strokeColor: theme.gray, selectedType: selectedType, "data-e2e": 'ToolCutModePage_ToolsCutHole' })), (0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, { in: !isUIHidden, timeout: 300, mountOnEnter: true, unmountOnExit: true, "data-e2e": 'ToolCutModePage_CSSTransition', children: (0, jsx_runtime_1.jsx)(StyledToolsCutLayersPanel, { type: type, "data-e2e": 'ToolCutModePage_StyledToolsCutLayersPanel' }) }), (0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, { in: !isUIHidden, timeout: 300, mountOnEnter: true, unmountOnExit: true, "data-e2e": 'ToolCutModePage_CSSTransition', children: (0, jsx_runtime_1.jsx)(StyledToolsCutOptionsPanel, { subtype: cutSubtype, type: type, onSelectType: setSelectedSubType, "data-e2e": 'ToolCutModePage_StyledToolsCutOptionsPanel' }) })] }));
}
exports.default = ToolCutModePage;
const StyledToolsCutLayersPanel = (0, styled_components_1.default)(ToolsCutLayers_1.default) `
  position: absolute;

  bottom: 0;
  left: 20px;

  ${(0, animation_1.SlideDown)('130%')}
`;
const StyledToolsCutOptionsPanel = (0, styled_components_1.default)(ToolsCutOptions_1.default) `
  position: absolute;
  bottom: 20px;
  left: calc(50% - 125px);

  ${(0, animation_1.SlideDown)('140%')}
`;
